import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { stripHtmlTags } from '@/app/utils/format';

export interface DataGAProps {
  click: boolean;
  eventName?: string;
  group?: string;
  url?: string;
  text?: unknown;
  value?: unknown;
}

export const safeText = (input: unknown): string | undefined => {
  if (typeof input === 'string') {
    const s = input.trim();
    return s ? stripHtmlTags(s) : undefined;
  }
  if (typeof input === 'number') {
    return String(input);
  }

  return undefined;
};

export const createDataGA = ({
  click,
  eventName,
  group,
  url,
  text,
  value,
}: DataGAProps) => {
  return createDataAttributes({
    'ga-click': click,
    'ga-event-name': eventName,
    'ga-group': group,
    'ga-url': url,
    'ga-text': safeText(text),
    'ga-value': safeText(value),
  });
};
